const headerData = [{
	"prop": "StatusName",
	"label": "状态",
	"columnwidth": 80
}, {
	"prop": "DPDate",
	"label": "出库日期",
	"columnwidth": 120
}, {
	"prop": "DPMonth",
	"label": "出库年月",
	"columnwidth": 100
}, {
	"prop": "VoucherType",
	"label": "单据类型",
	"columnwidth": 100
}, {
	"prop": "VouCode",
	"label": "单据号",
	"columnwidth": 180
}, {
	"prop": "CusName",
	"label": "付款方",
	"columnwidth": 180
}, {
	"prop": "Remark",
	"label": "备注",
	"columnwidth": 120
}, {
	"prop": "CreateTime",
	"label": "上报日期",
	"columnwidth": 120
}, {
	"prop": "InvClassName",
	"label": "产品线",
	"columnwidth": 120
}, {
	"prop": "TerminalHospitalName",
	"label": "终端医院",
	"columnwidth": 180
}, {
	"prop": "ProvinceName",
	"label": "省份",
	"columnwidth": 120
}, {
	"prop": "CityName",
	"label": "城市",
	"columnwidth": 120
}, {
	"prop": "SalesMan",
	"label": "销售代表 ",
	"columnwidth": 150
}, {
	"prop": "ProvinceMan",
	"label": "省级经理",
	"columnwidth": 150
}, {
	"prop": "AreaMan",
	"label": "小区经理",
	"columnwidth": 150
}, {
	"prop": "RegionMan",
	"label": "大区经理",
	"columnwidth": 150
}, {
	"prop": "CountryMan",
	"label": "全国总监",
	"columnwidth": 150
}, {
	"prop": "SurgeryDate",
	"label": "手术日期",
	"columnwidth": 120
}, {
	"prop": "TechnicalOffices",
	"label": "科室",
	"columnwidth": 120
}, {
	"prop": "Doctor",
	"label": "医生",
	"columnwidth": 120
}, {
	"prop": "SurgeryType",
	"label": "手术类型",
	"columnwidth": 150
}, {
	"prop": "InvAddCode",
	"label": "产品型号",
	"columnwidth": 120
}, {
	"prop": "InvName",
	"label": "产品名称",
	"columnwidth": 150
}, {
	"prop": "LEVEL1",
	"label": "LEVEL1",
	"columnwidth": 120
}, {
	"prop": "LEVEL2",
	"label": "LEVEL2",
	"columnwidth": 120
}, {
	"prop": "LEVEL3",
	"label": "LEVEL3",
	"columnwidth": 120
}, {
	"prop": "LEVEL4",
	"label": "LEVEL4",
	"columnwidth": 120
}, {
	"prop": "Batch",
	"label": "批号",
	"columnwidth": 120
}, {
	"prop": "ValiDate",
	"label": "有效期至",
	"columnwidth": 120
}, {
	"prop": "Quantity",
	"label": "数量",
	"columnwidth": 120
}, {
	"prop": "TaxUnitPrice",
	"label": "含税单价",
	"columnwidth": 120
}, {
	"prop": "Sum",
	"label": "价税合计",
	"columnwidth": 120
}, {
	"prop": "StandardCost",
	"label": "参考价格",
	"columnwidth": 120
}, {
	"prop": "StandardSum",
	"label": "参考价格（总计）",
	"columnwidth": 120
}, {
	"prop": "OrgStandardCost",
	"label": "标准价",
	"columnwidth": 120
}, {
	"prop": "OrgStandardSum",
	"label": "标准价合计",
	"columnwidth": 120
}, {
	"prop": "BackQuantity",
	"label": "退货数",
	"columnwidth": 120
}, {
	"prop": "DetailRemark1",
	"label": "明细备注1",
	"columnwidth": 120
}, {
	"prop": "DetailRemark2",
	"label": "明细备注2",
	"columnwidth": 120
}, {
	"prop": "DetailRemark3",
	"label": "明细备注3",
	"columnwidth": 120
}, {
	"prop": "DetailRemark4",
	"label": "明细备注4",
	"columnwidth": 120
}, {
	"prop": "DetailRemark5",
	"label": "明细备注5",
	"columnwidth": 120
}];
export default headerData;